import { render, staticRenderFns } from "./RecordingMode.vue?vue&type=template&id=027d4ae2&scoped=true"
import script from "./RecordingMode.vue?vue&type=script&lang=js"
export * from "./RecordingMode.vue?vue&type=script&lang=js"
import style0 from "./RecordingMode.vue?vue&type=style&index=0&id=027d4ae2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "027d4ae2",
  null
  
)

export default component.exports